const setVHVar = (height?: number) => {
  // Use visualViewport if available for more accurate height on iOS
  const visualViewport = window.visualViewport;
  const finalHeight = height ?? (visualViewport?.height || window.innerHeight);
  const vh = finalHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
};

export const setMobileVH = () => {
  const ua = (navigator.userAgent || '').toLowerCase();
  const isIOS = /iphone|ipad|ipod/.test(ua) && /applewebkit/.test(ua);
  if (!isIOS) return;
  setVHVar();
};

export const setupMobileVH = () => {
  const isIOS = () => {
    const ua = (navigator.userAgent || '').toLowerCase();
    const isAppleDevice = /iphone|ipad|ipod/.test(ua);
    const isWebkit = /applewebkit/.test(ua);
    return isAppleDevice && isWebkit;
  };

  if (!isIOS()) return;

  const updateVH = () => {
    setVHVar();
  };

  updateVH();
  
  // Listen to both resize and visualViewport resize for better handling
  window.addEventListener('resize', updateVH);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', updateVH);
  }

  return () => {
    window.removeEventListener('resize', updateVH);
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', updateVH);
    }
  };
};
